// CLOUDWEB-21024: ревизия Service Worker — хеш его собственного содержимого, который
// подставляет постобработка сборки (tasks/build_prepare.js).
//
// Пер-релизных значений (номер сборки, коммит) внутри файла воркера намеренно нет: браузер
// решает ставить нового воркера по байтовому отличию скрипта, поэтому любое такое значение
// приводило бы к переустановке воркера на каждой выкатке, сбросу его in-memory состояния и
// новому имени метрики версии. С хешем содержимого ревизия меняется тогда и только тогда,
// когда изменился код, попавший в бандл воркера.
//
// Соответствие «ревизия → релиз/коммит» лежит рядом в firebase-messaging-sw.version.json —
// вне воркера, поэтому на его байты не влияет.
const SW_REVISION = '8a967490b573';

/**
 * Ревизия исполняемого воркера. В дев-сборке подстановки не было — вернётся сам плейсхолдер,
 * и это ожидаемо: ревизия имеет смысл только для собранного артефакта.
 */
export function getSwRevision(): string {
    return SW_REVISION;
}
